import { useMemo } from 'react';

import { VFlex } from '@/components/base';
import List from '@/components/List/List';
import Typo from '@/components/Typography/Typo';
import { useHeySynclyHistory } from '@/entities/hey-syncly';
import { groupByTime } from '@/utils/groupByTime';

import { useHeySynclyPageStore } from '../../model/hey-syncly-page-store';
import { HistoryItem } from './history-item';

export const HistoryPanel = () => {
  const {
    data,
    isLoading,
    deleteHeySynclyChat,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useHeySynclyHistory();
  const currentChatAlias = useHeySynclyPageStore(
    (state) => state.currentChatAlias,
  );
  const onChatSelect = useHeySynclyPageStore((state) => state.onChatSelect);

  const groupedHistories = useMemo(() => {
    return groupByTime(data, 'created_at');
  }, [data]);

  return (
    <div className="flex flex-col">
      <List
        className="max-h-120 min-h-50 p-1 gap-2"
        data={groupedHistories}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        render={(group) => (
          <VFlex key={group.title} g={2}>
            <div className="h-7 flex items-center px-2">
              <Typo type="label3" weight="m" className="text-gray-500">
                {group.title}
              </Typo>
            </div>
            {group.items.map((history) => (
              <HistoryItem
                key={history.alias}
                selected={currentChatAlias === history.alias}
                history={history}
                onClick={onChatSelect}
                onDeleteClick={deleteHeySynclyChat}
              />
            ))}
          </VFlex>
        )}
        isLoading={isLoading}
      />
    </div>
  );
};
